import dayjs from 'dayjs';
import { useState } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { deletePost } from '../../../api/admin';
import styles from './Content.module.css';

const PostRow = ({ post, onDeleted }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const remove = async () => {
    if (!window.confirm(`Delete “${post.title}”? This cannot be undone.`)) return;
    setDeleting(true);
    setError('');
    try {
      const response = await deletePost(post.id);
      if (response.data.code === 200) onDeleted();
      else setError(response.data.message || 'Delete failed.');
    } catch {
      setError('Delete failed.');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <tr>
      <td><strong>{post.title}</strong>{error && <small className={styles.rowError}>{error}</small>}</td>
      <td>{post.author || 'Yi Chen'}</td>
      <td><span className={styles.languageBadge}>{post.lng === 'zh' ? '中文' : 'EN'}</span></td>
      <td>{dayjs(post.date).format('DD MMM YYYY')}</td>
      <td>
        <div className={styles.rowActions}>
          <Link to={`/admin/posts/${post.id}/edit`} aria-label={`Edit ${post.title}`}><FiEdit2 /></Link>
          <button type="button" onClick={remove} disabled={deleting} aria-label={`Delete ${post.title}`}><FiTrash2 /></button>
        </div>
      </td>
    </tr>
  );
};

export default PostRow;
